export default __webpack_public_path__ + "static/andy-0fda889a1c73da9aff1310a9f3bef36d.jpg";